import { useState } from "react";
import { useParams } from "react-router-dom";
import { Volume2, VolumeX } from "lucide-react";
import { useLanguage } from "../i18n";
import { IdentityUploadFlow } from "../components/IdentityUploadFlow";

export default function IdentityUpload() {
  const { token } = useParams();
  const { t } = useLanguage();
  const [person, setPerson] = useState(null);
  const [voiceOn, setVoiceOn] = useState(false);

  return (
    <div data-testid="identity-mobile-upload-page" className="min-h-dvh bg-[#FAF5EE] text-slate-900 overflow-x-hidden">
      <main className="mx-auto flex min-h-dvh w-full max-w-md flex-col justify-center px-5 py-6">
        <div className="text-center">
          <div data-testid="identity-mobile-logo" className="font-display text-4xl font-black tracking-tight">SIMAMMA<span className="text-[#FF6B35]">.</span></div>
          <p data-testid="identity-mobile-person" className="mt-3 font-mono-t text-[10px] font-bold uppercase tracking-[0.24em] text-slate-500">
            {person?.customer_name ? t("id.mobileFor").replace("{name}", person.customer_name) : t("id.eyebrow")}
          </p>
          <button type="button" data-testid="voice-instructions-toggle" onClick={() => setVoiceOn(!voiceOn)}
            className="mt-3 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 font-mono-t text-[9px] font-bold uppercase tracking-widest text-slate-500 hover:border-[#FF6B35] hover:text-[#FF6B35] transition-colors">
            {voiceOn ? <Volume2 className="w-3.5 h-3.5" /> : <VolumeX className="w-3.5 h-3.5" />}
            {voiceOn ? t("id.voiceOn") : t("id.voiceOff")}
          </button>
        </div>
        <div className="mt-6 rounded-[2rem] border border-slate-200/70 bg-white p-5 shadow-sm">
          <IdentityUploadFlow token={token} stepper voiceOn={voiceOn} onLoaded={setPerson} />
        </div>
      </main>
    </div>
  );
}
